import React from 'react';
import { Typography } from '@material-ui/core';

type Props = {}

const NotFoundPage: React.FC<Props> = () => (<Typography variant="h1">404</Typography>);

export default NotFoundPage;
